import { createContext, useContext } from "react";

import type { ScreenshotCaptureContext } from "./types.ts";

export const ScreenshotCapture = createContext<ScreenshotCaptureContext | undefined>(undefined);

export const useScreenshotCaptureContext = () => {
  const context = useContext(ScreenshotCapture);

  if (!context) throw new Error("No ScreenshotCaptureContext Provider found?");

  return context;
};
